import moment from "moment";
import React, { useState } from "react";

const getTime = () => moment().format("HH:mm");

export const Time = React.memo(() => {
  const [time, setTime] = useState(getTime());

  setInterval(() => {
    setTime(getTime());
  }, 1000);

  return time;
});
